// Copyright (c) Move Closer 2022.

import { MappingConfig, MappingTypes } from '@movecloser/front-core'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const reviewsAdapterMap: MappingConfig = {
  author: {
    type: MappingTypes.Function,
    value: (value) => {
      return value.author
    }
  },
  content: {
    type: MappingTypes.Function,
    value: (value) => {
      return value.content
    }
  },
  createdAt: {
    type: MappingTypes.Function,
    value: (value) => {
      return value.createdAt
    }
  },
  isVerified: {
    type: MappingTypes.Function,
    value: (value) => {
      return value.isVerified
    }
  },
  owner: {
    type: MappingTypes.Function,
    value: (value) => {
      return value.owner
    }
  },
  rate: {
    type: MappingTypes.Function,
    value: (value) => {
      return value.rate
    }
  }
}

export const reviewModelConfigAdapter: MappingConfig = {
  ratingConfigId: {
    type: MappingTypes.Function,
    value: () => {
      /**
       * TODO: Remove to Site properties
       */
      return 'NA=='
    }
  },
  author: 'author',
  sku: 'sku',
  summary: 'summary',
  text: 'content',
  ratingConfigValue: {
    type: MappingTypes.Function,
    value: (item) => {
      /**
       * TODO: Remove to Site properties
       */
      const values = [
        {
          valueId: 'MTY=',
          value: '1'
        },
        {
          valueId: 'MTc=',
          value: '2'
        },
        {
          valueId: 'MTg=',
          value: '3'
        },
        {
          valueId: 'MTk=',
          value: '4'
        },
        {
          valueId: 'MjA=',
          value: '5'
        }
      ]

      for (const value of values) {
        if (value.value.toString() === item.ratingConfigValue.toString()) {
          return value.valueId
        }
      }
    }
  }
}
